export default {
	namespaced: true, // 当 namespaced 设置为true之后引入在index中的时候不会与其他相同名称的数据或方法发生冲突
	state: {
        isBriefIntroductionShow: false, // 简介显示状态
        isRouterdetailsShow: false, // 路线简介
        leftActiveIndex: -1, // 左侧列表激活的index
        bottomActiveIndex: -1, // 底部列表激活的index
        rightListState: [ // 右侧列表激活状态，右侧列表不会互斥，所以需要使用数组存储
            {
                flag: false,
                index: 0,
            },
            {
                flag: false,
                index: 1,
            },
            {
                flag: false,
                index: 2,
            },
            {
                flag: false,
                index: 3,
            },
            {
                flag: false,
                index: 4,
            }
        ],
        detailedData: {},
        leftlist: [
            {
                url1: require("@/assets/svg/map/leftList0.svg"),
                url2: require("@/assets/svg/map/leftList0_active.svg"),
                title: "停车场",
            },
            {
                url1: require("@/assets/svg/map/leftList1.svg"),
                url2: require("@/assets/svg/map/leftList1_active.svg"),
                title: "加油站",
            },
            {
                url1: require("@/assets/svg/map/leftList2.svg"),
                url2: require("@/assets/svg/map/leftList2_active.svg"),
                title: "卫生间",
            }
        ]
	},
	mutations: {
        setLeftActiveIndex(state,index){ // 设置左侧激活的index值
            state.isRouterdetailsShow = false;
            if(state.leftActiveIndex == index){ // 判断左侧列表当前点击的index是否处于激活状态
                state.leftActiveIndex = -1; // 解除激活状态
            }else{
                if(state.bottomActiveIndex != -1){ // 判断底部列表是否有个体被激活
                    state.bottomActiveIndex = -1; // 将底部列表的激活解除
                }
                state.leftActiveIndex = index; // 激活当前点击的个体
            }
        },
        setBottomActiveIndex(state,index){ // 设置底部激活的index值
            state.isRouterdetailsShow = false;
            if(state.bottomActiveIndex == index){
                state.bottomActiveIndex = -1;
            }else{
                if(state.leftActiveIndex != -1){
                    state.leftActiveIndex = -1;
                }
                state.bottomActiveIndex = index;
                // if(index != 2){
                //     state.isRouterdetailsShow = false;
                // }
            }
             // console.log("底部激活值是",state.bottomActiveIndex);
        },
        setRightListState(state,index){
            if(index == -1){
                state.rightListState.forEach(item => {
                    item.flag = false;
                })
            }
            else{
                state.rightListState.splice(index,1,{
                    flag: !state.rightListState[index].flag,
                    index: state.rightListState[index].index
                });
            }
        },
        // 简介显示 / 隐藏状态
        briefIntroductionShow(state){
            state.isBriefIntroductionShow = true;
        },
        briefIntroductionHide(state){
            state.isBriefIntroductionShow = false;
        },
        // 路线简介显示 / 隐藏状态
        routerdetailsShow(state){
            state.isRouterdetailsShow = true;
        },
        routerdetailsHide(state){
            state.isRouterdetailsShow = false;
        },
        setDetailedData(state,obj){
            state.detailedData = obj;
        }
	}
}